// import { useDebounce } from "@uidotdev/usehooks";
// import { useEffect, useRef, useState } from "react";
// import { useDispatch } from "react-redux";
// import { cn } from "~/lib/utils";
// import { commonActions } from "~/redux/slice/common";
// import { Icon } from "./icon";
// interface Props {
//   isOpen: boolean;
//   setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
// }
// const SearchWithAnimation = ({ isOpen, setIsOpen }: Props) => {
//   const dispatch = useDispatch();
//   const [searchValue, setSearchValue] = useState("");
//   const debouncedSearchTerm = useDebounce(searchValue, 300);
//   const inputRef = useRef<HTMLInputElement | null>(null); // Properly typing the ref
//   const [isFocused, setIsFocused] = useState(false);
//   useEffect(() => {
//     console.log(debouncedSearchTerm, "debouncedSearchTerm");
//     dispatch(commonActions.setSearchValue(debouncedSearchTerm));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [debouncedSearchTerm]);
//   // Function to handle the click event to toggle search input and autofocus
//   // const handleClick = () => {
//   //   setIsOpen(!isOpen);
//   //   if (!isOpen && inputRef.current) {
//   //     // Focus the input when it opens
//   //     inputRef.current.focus();
//   //   }
//   // };
//   const handleIconClick = () => {
//     if (searchValue) {
//       // If there's a search value, clear it
//       setSearchValue("");
//       setIsOpen(false);
//     } else {
//       // If no search value, open the search
//       setIsOpen(!isOpen);
//       if (!isOpen && inputRef.current) {
//         inputRef.current.focus();
//       }
//     }
//   };
//   return (
//     <div
//       className={cn(
//         `flex items-center bg-white px-2 py-2 transition-all duration-500 ease-in-out`,
//         isOpen && isFocused && "border-b border-b-black",
//       )}
//     >
//       {/* Search Input */}
//       <input
//         ref={inputRef} // Attach the input reference
//         value={searchValue}
//         onChange={(e) => setSearchValue(e.target.value)}
//         type="text"
//         onFocus={() => setIsFocused(true)}
//         onBlur={() => {
//           setIsFocused(false);
//           setIsOpen(false);
//         }}
//         placeholder={isFocused ? "Start Typing" : "Search"}
//         autoFocus
//         className={cn(
//           "flex-grow bg-transparent text-sm outline-none transition-all duration-500 ease-in-out",
//           isOpen && isFocused ? "w-72 px-4" : "w-0", // Adjust the width when input is open
//         )}
//       />
//       {/* Search Icon */}
//       <div
//         onClick={handleIconClick}
//         className="flex size-6 cursor-pointer items-center justify-center transition-transform duration-500 ease-in-out"
//       >
//         <Icon
//           name="Search"
//           className={cn("h-5 w-5 text-neutral-400", {
//             "text-primary-500": isFocused || searchValue,
//           })}
//         />
//       </div>
//     </div>
//   );
// };
// export default SearchWithAnimation;
// ===== FIXED SearchWithAnimation Component =====
import { useDebounce } from "@uidotdev/usehooks";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { cn } from "~/lib/utils";
import { commonActions } from "~/redux/slice/common";
import { useSelector } from "~/redux/store";

import { Icon } from "./icon";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SearchWithAnimation = ({ isOpen, setIsOpen }: Props) => {
  const dispatch = useDispatch();
  // ✅ Fixed: Get search value from Redux store
  const searchInputFromRedux = useSelector((state) => state.common.searchInput);
  const [searchValue, setSearchValue] = useState(searchInputFromRedux || "");
  const debouncedSearchTerm = useDebounce(searchValue, 300);

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isFocused, setIsFocused] = useState(false);

  // ✅ Fixed: Sync local state with Redux state when component mounts/remounts
  useEffect(() => {
    setSearchValue(searchInputFromRedux || "");
  }, [searchInputFromRedux]);

  useEffect(() => {
    dispatch(commonActions.setSearchValue(debouncedSearchTerm));
  }, [debouncedSearchTerm, dispatch]);

  // Function to handle the click event to toggle search input and autofocus
  const handleClick = () => {
    setIsOpen(!isOpen);
    if (!isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  };

  // ✅ Fixed: Clear search function that properly resets everything
  const clearSearch = () => {
    setSearchValue("");
    setIsOpen(false);
    setIsFocused(false);
  };

  return (
    <div
      className={cn(
        `flex items-center bg-white px-2 py-2 transition-all duration-500 ease-in-out`,
        isOpen && isFocused && "border-b border-b-black",
      )}
    >
      {/* Search Input */}
      <input
        ref={inputRef}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        type="text"
        onFocus={() => setIsFocused(true)}
        onBlur={() => {
          setIsFocused(false);
          setIsOpen(false);
          // ✅ Fixed: Don't reset search value here - keep the search active
        }}
        placeholder={isFocused ? "Start Typing" : "Search"}
        autoFocus
        className={cn(
          "flex-grow bg-transparent text-sm outline-none transition-all duration-500 ease-in-out",
          isOpen && isFocused ? "w-72 px-4" : "w-0",
        )}
      />

      {/* ✅ Fixed: Dynamic Search Icon or Clear Button */}
      <div
        onClick={searchValue ? clearSearch : handleClick}
        className="flex size-6 cursor-pointer items-center justify-center transition-transform duration-500 ease-in-out"
      >
        <Icon
          name={searchValue ? "X" : "Search"}
          className={cn("h-5 w-5 text-neutral-400", {
            "text-primary-500": isFocused || searchValue,
          })}
        />
      </div>
    </div>
  );
};

export default SearchWithAnimation;
